import { fcaFastApi, fcaGateWay } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

// Migrated documents endpoints share the SAME paths on Ruby and FastAPI;
// only the gateway (base URL) switches on the migration flag.
const documentsGateway = () => (isEnabled("migrate_narratives_documents") ? fcaFastApi : fcaGateWay);

// File uploads (create / update-with-file) are async on the backend and stay
// on the legacy Ruby gateway; only metadata-only calls are repointed.
const hasFilePart = data => {
    if (typeof FormData === "undefined" || !(data instanceof FormData)) return false;
    const file = data.get && data.get("file");
    return typeof Blob !== "undefined" && file instanceof Blob;
};

export const getAllReports = (params, id) =>
    documentsGateway().get(`${serviceEndpoints.reportEndPoints.getAllReports}`, {
        params
    });
export const addDocument = params => fcaGateWay.post(`${serviceEndpoints.reportEndPoints.getAllReports}`, params);
export const getDocumentById = id => documentsGateway().get(`${serviceEndpoints.reportEndPoints.getAllReports}/${id}`);
export const updateDocument = (id, params) =>
    (hasFilePart(params) ? fcaGateWay : documentsGateway()).patch(`${serviceEndpoints.reportEndPoints.getAllReports}/${id}`, params);
export const deleteDocument = (id, params) => documentsGateway().delete(`${serviceEndpoints.reportEndPoints.getAllReports}/${id}`, { params });
export const getListForCommonFilter = params =>
    documentsGateway().get(`${serviceEndpoints.reportEndPoints.getAllReports}/get_list`, {
        params
    });
export const exportDocuments = params =>
    fcaGateWay.get(`${serviceEndpoints.reportEndPoints.getAllReports}/export_xl`, { method: "GET", responseType: "blob", params });
export const getAllDocumentLogs = (id, params) => {
    return documentsGateway().get(`${serviceEndpoints.reportEndPoints.getAllReports}/${id}/logs`, { params });
};
export const restoreDocumentLog = id => fcaGateWay.patch(`${serviceEndpoints.reportEndPoints.restoreDocumentLog}/${id}/restore`);
export const deleteDocumentLog = id => fcaGateWay.delete(`${serviceEndpoints.reportEndPoints.deleteDocumentLog}/${id}`);

export const getInitiativeDropdown = params => fcaGateWay.get(`${serviceEndpoints.reportEndPoints.getInitiativeDropdown}`, { params });

export const getRecommendationDropdown = params => fcaGateWay.get(`${serviceEndpoints.reportEndPoints.getRecommendationDropdown}`, { params });

export const getAllRegionDropdownDocument = params => fcaGateWay.get(`${serviceEndpoints.siteEndPoints.getRegionsBasedOnClient}`, { params });

export const getAllDocuments = params => fcaGateWay.get(`${serviceEndpoints.reportEndPoints.getDocumentTypeBased}`, { params });

export const getSitesByRegionInDocuments = id =>
    fcaGateWay.get(`${serviceEndpoints.reportEndPoints.getSitesByRegionInDocuments}/${id}/site_dropdown`);

export const getMasterFilterLists = (key, params) => fcaGateWay.get(`${serviceEndpoints.reportEndPoints.filterLists[key]}`, { params });
export const recoverDocument = id => fcaGateWay.patch(`${serviceEndpoints.reportEndPoints.recoverDocument}/${id}/restore`);